import { render, staticRenderFns } from "./EvaluacionesDesempenioTable.vue?vue&type=template&id=23ff149a"
import script from "./EvaluacionesDesempenioTable.vue?vue&type=script&lang=js"
export * from "./EvaluacionesDesempenioTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports